/* global jQuery */
void (function themeStart($) {
	'use strict';
	$(document).ready(() => {
		// Global variables
		const $mainNav = $('.mobile-nav');
		const $navToggle = $('#navToggle');

		// When clicking the main nav toggle button...
		$navToggle.on('click', (event) => {
			event.preventDefault();

			// Find initial nav state
			const navIsHidden = $mainNav.attr('aria-hidden') === 'true';

			// Find what the current state of nav should be
			let newNavState;
			if (navIsHidden) {
				newNavState = {
					label: 'Hide Menu',
					expanded: true,
					hidden: false,
				};
			} else {
				newNavState = {
					label: 'Show Menu',
					expanded: false,
					hidden: true,
				};
			}

			// Updating new main nav state
			$navToggle.attr({
				'aria-label': newNavState.label,
				'aria-expanded': newNavState.expanded,
			});
			$mainNav.attr({ 'aria-hidden': newNavState.hidden });
		});

		const headerPosition =
			$('header').position().top + $('header').outerHeight();
		const headerHeight = $('header').outerHeight();

		$(window).scroll(() => {
			if ($(window).scrollTop() > headerPosition) {
				if (!$('header').hasClass('fixed')) {
					$('header').addClass('fixed');
					$('body').css('padding-top', headerHeight);
				}
			} else if ($(window).scrollTop() < $('header').position().top + 1) {
				$('header').removeClass('fixed');
				$('body').css('padding-top', '0');
			}
		});

		$('.page-text').each((index, element) => {
			if ($(element).text() === 'Home') {
				$(element).parents('.nav--menu-item').addClass('logo');
			}
		});

		const oneSecond = 1000;
		$('.demo-link').click((e) => {
			e.preventDefault();
			$('html, body').animate(
				{
					scrollTop: $('.banner--cta').offset().top - headerHeight,
				},
				oneSecond,
			);
		});
	});
})(jQuery);
